export default __webpack_public_path__ + "static/media/hero-bg.46044bc6.png";